import { DateRecurField } from '@uncinc/react-drupal-core/types';

const formatEventDates = (dates: DateRecurField[]) => {
  let formattedDates: DateRecurField['dates'] = [];

  // Put all the dates in a single array.
  dates.forEach((dateValue) => {
    formattedDates = [...formattedDates, ...dateValue.dates];

    // If the date value doesn't have `.dates`,
    // then we want to use it's own date.
    if (dateValue.dates.length === 0) {
      formattedDates.push({
        start: {
          date: dateValue.value,
          timezone: dateValue.timezone,
          timezone_type: true,
        },
        end: {
          date: dateValue.end_value,
          timezone: dateValue.timezone,
          timezone_type: true,
        },
      });
    }
  });

  // Sort the array based on the start dates.
  formattedDates.sort((a, b) => {
    const dateA = new Date(a.start.date);
    const dateB = new Date(b.start.date);

    if (dateA < dateB) {
      return -1;
    }

    if (dateA > dateB) {
      return 1;
    }

    return 0;
  });

  return formattedDates;
};

export default formatEventDates;
